/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FieldMapping } from '../../models/field-mapping';
import { FieldMappingApiRespModel } from '../../models/field-mapping-api-resp-model';

export interface ApiMasterFieldMappingAddPost$Params {
      body?: FieldMapping
}

export function apiMasterFieldMappingAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterFieldMappingAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FieldMappingApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterFieldMappingAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FieldMappingApiRespModel>;
    })
  );
}

apiMasterFieldMappingAddPost.PATH = '/api/Master/FieldMapping/Add';
